<ion-menu contentId="main" [class.hidden]="this.currentUrl === '/login'">
  <div class="profile-part" [routerLink]="'/profile'" (click)="closeMenu()">
    <img *ngIf="currentUser | userPhotoUrl as photoUrl; else menuPersonIcon" [src]="photoUrl" class="profil-photo" alt="">
    <ng-template #menuPersonIcon>
      <mat-icon class="profil-icon" >person</mat-icon>
    </ng-template>
    <div class="current-user">
      <div class="username">{{ currentUser?.nom }} {{ currentUser?.prenom }}</div>
      <div class="link">
        <span>
          {{'menu.voirProfil' | translate}}
        </span>
        <mat-icon>chevron_right</mat-icon> 
      </div>
    </div>
  </div>
  <ion-content class="ion-padding">
    <ion-list>
      <ion-item  [routerLink]="'/evenements'" (click)="closeMenu()">
        <mat-icon>list</mat-icon>
        <span>
          {{'menu.evenements' | translate}}
        </span>
      </ion-item>
      <ion-item [routerLink]="'/planning'" (click)="closeMenu()">
        <mat-icon>calendar_today</mat-icon>
        <span>
          {{'menu.planning' | translate}}
        </span>
      </ion-item>
      <ion-item [routerLink]="'/partitions'" (click)="closeMenu()">
        <mat-icon>library_music</mat-icon>
        <span>
          {{'menu.partitions' | translate}}
        </span>
      </ion-item>
      <ion-item [routerLink]="'/groupes'" (click)="closeMenu()">
        <mat-icon>group</mat-icon>
        <span>
          {{'menu.groupe' | translate}}
        </span>
      </ion-item>
      <ion-item [routerLink]="'/organismes'" (click)="closeMenu()">
        <mat-icon>group_work</mat-icon>
        <span>
          {{'menu.organismes' | translate}}
        </span>
      </ion-item>
      <ion-item *ngIf="comptesPartages && comptePartageEnCours === null" [routerLink]="'/comptes-partages'" (click)="closeMenu()">
        <mat-icon>account_child_invert</mat-icon>
        <span>
          {{'menu.comptesPartages' | translate}}
        </span>
      </ion-item>
      <ion-item class="invitations" [routerLink]="'/invitations'" [class.bold]="invitationsLength > 0" (click)="closeMenu()">
        <mat-icon>mail</mat-icon>
        <span>
          {{'menu.invitations' | translate}} {{invitationsLength > 0 ? '('+invitationsLength+')' : ''}} 
        </span>
      </ion-item>
      <ion-item class="logout" (click)="logout()">
        <mat-icon>logout</mat-icon>
        <span>
          {{'menu.deconnexion' | translate}}
        </span>
      </ion-item>
    </ion-list>
  </ion-content>
</ion-menu>
